import ShiftInformationTable from "@shared-containers/ShiftInformationTable";
import { CustomCardWrapper } from "./style";

const ShiftInformationAll = () => {
  return (
    <CustomCardWrapper>
      <ShiftInformationTable pagination />
    </CustomCardWrapper>
  );
};

export default ShiftInformationAll;
